<template>
    <div v-if="!isFetching">
        <div
            v-if="!dataLength"
            class="box-body with-border clearfix"
        >
            <p>There are no Short Domains for this Short Domain Account.</p>
        </div>
        <div v-else>
            <div
                v-if="shortDomains.total"
                class="box-body with-border clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <BadgeTotal
                    :value="shortDomains.total"
                    color="gray"
                    :label="`${$t('total')}: `"
                />

                <pagination
                    :class="isDisabled()"
                    :data="shortDomains"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-striped table-hover">
                    <tbody>
                        <tr>
                            <th>ID</th>
                            <th>Relation</th>
                            <th v-if="displayAccount">Account</th>
                            <th>Name</th>
                            <th>IP</th>
                            <th>Redirect URL</th>
                            <th class="text-left">Messages</th>
                            <th class="text-left">Clicks</th>
                            <th class="text-center">Uses</th>
                            <th class="text-center">SSL Active</th>
                            <th class="text-center">Active</th>
                            <th class="text-center">Reusable</th>
                            <th class="text-center">Status</th>
                            <th class="text-right">Created At</th>
                            <th class="text-right">Expires At</th>
                            <th class="text-right">Parsed At</th>
                            <th class="text-right">Updated At</th>
                            <th></th>
                        </tr>
                        <tr
                            v-for="shortDomain in shortDomains.data"
                            :key="shortDomain.id"
                        >
                            <td>{{ shortDomain.id }}</td>
                            <td>
                                <span v-if="shortDomain.domainable_type === type.campaign">
                                    <a
                                        v-if="shortDomain.domainable_id"
                                        :href="getRoute(shortDomain.domainable_id, 'campaignsShow')"
                                    >
                                        Lap #{{ shortDomain.domainable_id }}
                                    </a>
                                    <em
                                        v-else
                                        class="text-info"
                                        >Lap</em
                                    >
                                </span>
                                <span v-else-if="shortDomain.domainable_type === type.feedback">
                                    <a
                                        v-if="shortDomain.domainable_id"
                                        :href="getRoute(shortDomain.domainable_id, 'feedbackShow')"
                                    >
                                        Lap #{{ shortDomain.domainable_id }}
                                    </a>
                                    <em
                                        v-else
                                        class="text-info"
                                        >Feedbacks</em
                                    >
                                </span>
                                <span v-else>
                                    <em class="text-info">None</em>
                                </span>
                            </td>
                            <td v-if="hasAdmin && displayAccount">
                                <a
                                    :href="getRoute(shortDomain.account.id, 'sdAccountsShow')"
                                    :title="shortDomain.account.name"
                                >
                                    {{ shortDomain.account.name }}
                                </a>
                            </td>
                            <td v-else-if="displayAccount">{{ shortDomain.account.name }}</td>
                            <td>{{ shortDomain.name }}</td>
                            <td>{{ shortDomain.formatted_ip }}</td>
                            <td><ValueEmpty :value="shortDomain.redirect_url" /></td>
                            <td>
                                <img
                                    v-show="!isLoaded"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="shortDomain.messages_count"
                                    color="gray"
                                    title="Total"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="shortDomain.messages_sent"
                                    color="green"
                                    title="Sent"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="shortDomain.messages_failed"
                                    color="red"
                                    title="Failed"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="shortDomain.messages_blacklisted"
                                    color="black"
                                    title="Blacklisted"
                                />
                            </td>
                            <td>
                                <img
                                    v-show="!isLoaded"
                                    alt="Preloader"
                                    class="table-row-preloader"
                                    rel="preload"
                                    src="/img/table-row-preloader.gif"
                                />
                                <BadgeTotal
                                    v-show="isLoaded"
                                    :value="shortDomain.clicks_count"
                                    color="aqua-active"
                                    title="Amount"
                                />
                            </td>
                            <td class="text-center">
                                <BadgeTotal
                                    :value="shortDomain.order_uses"
                                    color="gray"
                                />
                            </td>
                            <td class="text-center">
                                <ValueYesNo :value="shortDomain.ssl_active" />
                            </td>
                            <td class="text-center">
                                <ValueYesNo :value="shortDomain.active" />
                            </td>
                            <td class="text-center">
                                <ValueYesNo :value="shortDomain.reusable" />
                            </td>
                            <td class="text-center">
                                <span :class="'label bg-' + shortDomain.formatted_status_color">
                                    {{ shortDomain.formatted_status }}
                                </span>
                            </td>
                            <td class="text-right">
                                <ValueEmpty :value="shortDomain.formatted_created_at" />
                            </td>
                            <td class="text-right">
                                <ValueEmpty :value="shortDomain.formatted_expires_at" />
                            </td>
                            <td class="text-right">{{ shortDomain.created_at }}</td>
                            <td class="text-right">{{ shortDomain.updated_at }}</td>
                            <td
                                class="text-right"
                                width="100px"
                            >
                                <button
                                    v-if="isActiveEnabled(shortDomain.status) && shortDomain.active"
                                    class="btn btn-sm btn-danger"
                                    data-toggle="modal"
                                    data-target="#confirm-active-modal"
                                    @click="activeShortDomain = shortDomain"
                                >
                                    <i class="fa fa-ban"></i>
                                    <span class="sr-only">Deactivate</span>
                                </button>
                                <button
                                    v-else-if="isActiveEnabled(shortDomain.status)"
                                    class="btn btn-sm btn-success"
                                    data-toggle="modal"
                                    data-target="#confirm-active-modal"
                                    @click="activeShortDomain = shortDomain"
                                >
                                    <i class="fa fa-check"></i>
                                    <span class="sr-only">Activate</span>
                                </button>
                                <a
                                    :href="getRoute(shortDomain.id, 'show')"
                                    class="btn btn-sm btn-info"
                                >
                                    <i class="fa fa-eye"></i>
                                    <span class="sr-only">Show</span>
                                </a>
                                <a
                                    :href="getRoute(shortDomain.id, 'edit')"
                                    class="btn btn-sm btn-primary"
                                >
                                    <i class="fa fa-edit"></i>
                                    <span class="sr-only">Edit</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div
                v-if="shortDomains.total"
                class="box-footer clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    :data="shortDomains"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
        </div>

        <ModalDialog
            id="confirm-active-modal"
            ref="modal"
            size="sm"
            :isLoading="isLoading"
            @submit="changeActive"
        >
            <template #header> {{ activeShortDomain.active ? 'Deactivate' : 'Activate' }} Short domain?</template>

            <template #body>
                <p>Short domain #{{ activeShortDomain.id }}</p>
            </template>

            <template #footer="{ close, submit }">
                <button
                    class="btn btn-sm btn-default"
                    type="button"
                    data-dismiss="modal"
                    :disabled="isLoading"
                    @click="close"
                >
                    {{ $t('cancel') }}
                </button>

                <button
                    class="btn btn-sm"
                    :class="{
                        'btn-danger': activeShortDomain.active,
                        'btn-success': !activeShortDomain.active,
                    }"
                    :disabled="isLoading"
                    @click="submit"
                >
                    <i
                        v-if="isLoading"
                        class="fa fa-refresh fa-spin"
                    />
                    <span>{{ activeShortDomain.active ? 'Deactivate' : 'Activate' }}</span>
                </button>
            </template>
        </ModalDialog>
    </div>
</template>

<script>
import EventBus from '@/event-bus';
import BadgeTotal from '@/components/subcomponents/BadgeTotal';
import ValueYesNo from '@/components/subcomponents/ValueYesNo';
import ValueEmpty from '@/components/subcomponents/ValueEmpty';
import ModalDialog from '@/components/modals/ModalDialog';

export default {
    components: {
        BadgeTotal,
        ValueYesNo,
        ValueEmpty,
        ModalDialog,
    },
    props: {
        route: {
            type: Object,
            default: () => ({}),
        },
        type: {
            type: Object,
            default: () => ({}),
        },
        displayAccount: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            shortDomains: {},
            isFetching: true,
            isLoaded: false,
            disablePagination: true,
            hasAdmin: false,
            ncData: false,
            activeShortDomain: {},
        };
    },
    computed: {
        dataLength() {
            return this.shortDomains.data.length;
        },
    },
    mounted() {
        this.getData(this.$route.query.page);

        $('#shortDomainDeactivateModal').on('hidden.bs.modal', function () {
            $(this).find('.short-domain-id').text('');
        });
    },
    methods: {
        async changeActive() {
            if (!this.isActiveEnabled(this.activeShortDomain.status)) return;

            try {
                this.isLoading = true;

                const requestData = {
                    id: this.activeShortDomain.id,
                    active: !this.activeShortDomain.active,
                };

                const {
                    data: { shortDomain },
                } = await axios.put('/short-domains/data/short-domain', requestData);

                this.shortDomains.data.forEach((item) => {
                    if (item.id === shortDomain.id) {
                        item.active = shortDomain.active;
                    }
                });

                this.$refs.modal.close();
            } catch (error) {
                if (error.response) {
                    EventBus.$emit('alertData', {
                        class: 'alert-danger',
                        message: error.response.data.message,
                        errors: error.response.data.errors,
                    });
                }
            } finally {
                this.isLoading = false;
            }
        },
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        async getData(page = 1) {
            this.$router
                .replace({
                    query: {
                        ...this.$route.query,
                        page: page > 1 ? page : undefined,
                    },
                })
                .catch(() => {});

            this.disablePagination = true;
            this.isLoaded = false;

            const { data } = await axios.get(`${this.$route.path}/data?page=${page}`);

            if (page > data.shortDomains.last_page) {
                return this.getData();
            }

            this.shortDomains = data.shortDomains;
            this.hasAdmin = data.hasAdmin;
            this.isFetching = false;

            if (this.shortDomains.data.length) {
                this.getStats(_.map(this.shortDomains.data, 'id'));
            }

            this.$emit('loaded', true);
        },
        getStats(ids) {
            this.isLoaded = false;
            axios.get('/short-domains/stats?ids=' + ids).then((response) => {
                let sort = _.merge(_.keyBy(this.shortDomains.data, 'id'), _.keyBy(response.data, 'id'));
                this.shortDomains.data = _.orderBy(sort, ['id'], ['desc']);
                this.isLoaded = true;
                this.disablePagination = !this.isLoaded;
            });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
        isActiveEnabled(status) {
            return !['FRESH'].includes(status);
        },
    },
};
</script>
